import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Flex,
  HStack,
  Heading,
  Image,
  Text,
  useToast,
} from '@chakra-ui/react';
import { useAdminLeave } from './AdminLeave';

function AdminHeader({ title, activeTab, badge, fullWidth = false }) {
  const navigate = useNavigate();
  const toast = useToast();
  const { confirmLeave } = useAdminLeave();

  const go = (path) => {
    if (!confirmLeave()) return;
    navigate(path);
  };

  const handleLogout = () => {
    if (!confirmLeave()) return;
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUsername');
    navigate('/Admin');
    toast({
      description: 'Logged out successfully',
      status: 'success',
      duration: 2000,
      isClosable: true,
      position: 'bottom',
    });
  };

  return (
    <Box bg="white" borderBottom="1px solid" borderColor="gray.200" py={4} mb={6}>
      <Container maxW={fullWidth ? 'full' : '7xl'} px={fullWidth ? { base: 4, md: 6 } : undefined}>
        <Flex justify="space-between" align="center" wrap="wrap" gap={4}>
          <HStack spacing={4}>
            <Image
              src="/assets/images/white-logo.svg"
              alt="BLRC Logo"
              maxH="40px"
              fallback={
                <Text fontSize="xl" fontWeight="bold" color="blue.600">
                  BLRC
                </Text>
              }
            />
            <Heading size="lg" color="gray.800" fontWeight="700">
              {title}
            </Heading>
          </HStack>
          <HStack spacing={4} flexWrap="wrap">
            {badge}
            <Text fontSize="sm" color="gray.600">
              Welcome, <strong>{localStorage.getItem('adminUsername') || 'Admin'}</strong>
            </Text>
            <Button
              colorScheme="red"
              size="sm"
              onClick={handleLogout}
              borderRadius="md"
              fontWeight="600"
            >
              Logout
            </Button>
          </HStack>
        </Flex>
        <HStack mt={4} pt={4} spacing={3} borderTop="1px solid" borderColor="gray.100" flexWrap="wrap">
          <Button
            size="sm"
            borderRadius="md"
            fontWeight="600"
            colorScheme="blue"
            variant={activeTab === 'contacts' ? 'solid' : 'outline'}
            onClick={() => go('/Admin/Contacts')}
          >
            Contacts
          </Button>
          <Button
            size="sm"
            borderRadius="md"
            fontWeight="600"
            colorScheme="blue"
            variant={activeTab === 'blog' ? 'solid' : 'outline'}
            onClick={() => go('/Admin/Blog')}
          >
            Blog
          </Button>
          <Button
            size="sm"
            borderRadius="md"
            fontWeight="600"
            colorScheme="blue"
            variant={activeTab === 'visitors' ? 'solid' : 'outline'}
            onClick={() => go('/Admin/Visitors')}
          >
            Visitors
          </Button>
          <Button
            size="sm"
            borderRadius="md"
            fontWeight="600"
            colorScheme="blue"
            variant={activeTab === 'whatsapp' ? 'solid' : 'outline'}
            onClick={() => go('/Admin/WhatsApp')}
          >
            WhatsApp
          </Button>
        </HStack>
      </Container>
    </Box>
  );
}

export default AdminHeader;
